<template>
  <div class="shipping-block">
    <div class="step__block-container">
      <h3 class="step__block-title">Shipping:</h3>
      <div class="step__block-row">
        <CheckboxField v-model="estimate.isShippingAndBillingEqual" />
        <p class="step__block-text">same address</p>
      </div>
    </div>

    <div class="step__block-fields">
      <div class="step__block-container">
        <span class="step__block-container-left">Address:</span>
        <input type="text" v-model="estimate.client.shippingAddress" placeholder="NY, Boynton Avenue, 1145"
          autocomplete="new-password" :disabled="isShippingAndBillingEqual" />
      </div>

      <div class="step__block-container">
        <span class="step__block-container-left label-required">ZIP:</span>
        <ShippingZipCode v-model:zip="estimate.shippingZip" v-model:state="estimate.shippingState" type="shipping"
          :disabled="isShippingAndBillingEqual" />
      </div>

      <div class="step__block-container">
        <span class="step__block-container-left label-required"> State: </span>
        <ShippingStatesSelect v-model:state="estimate.shippingState" :disabled="isShippingAndBillingEqual" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { CheckboxField } from "@/shared";

import { ShippingZipCode, ShippingStatesSelect } from "@/modules/shipping";

const estimateStore = useNewEstimateStore();
const estimate = computed(() => estimateStore.estimate);
const isShippingAndBillingEqual = computed(
  () => estimate.value.isShippingAndBillingEqual,
);

watch(
  () => estimate.value.shippingState,
  (shippingState) => {
    if (!isShippingAndBillingEqual.value) return;

    estimate.value.client.billingState = shippingState;
  },
);

watch(
  () => estimate.value.shippingZip,
  (shippingZip) => {
    if (!isShippingAndBillingEqual.value) return;

    estimate.value.client.billingZip = shippingZip;
  },
);

watch(
  () => estimate.value.client.shippingAddress,
  (shippingAddress) => {
    if (!isShippingAndBillingEqual.value) return;

    estimate.value.client.billingAddress = shippingAddress;
  },
);

watch(
  () => [
    estimate.value.isShippingAndBillingEqual,
    estimate.value.client.billingAddress,
    estimate.value.client.billingZip,
  ],
  ([val]) => {
    if (val) {
      estimate.value.client.shippingAddress =
        estimate.value.client.billingAddress;
      estimate.value.shippingZip = estimate.value.client.billingZip;
    }
  }
);

watch(
  () => estimate.value.isShippingAndBillingEqual,
  (val) => {
    if (!val) {
      estimate.value.client.shippingAddress = "";
      estimate.value.shippingZip = "";
      estimate.value.shippingState = "";
    }
  }
);
</script>

<style scoped>
.shipping-block {
  margin-block: 12px;
}

.step__block-container {
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: grid;
  grid-template-columns: 40% 60%;
  column-gap: 10px;
}

.step__block-fields {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.step__block .step__block-container-left {
  align-self: center;
}

.step__block--data .step__block-container input,
.step__block-wrapper .step__block-container input {
  padding: 9px 20px;
  background-color: #fff;
  border-radius: 25px;
  color: #404d63;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step__block--data .step__block-container input:disabled,
.step__block-wrapper .step__block-container input:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.step__block-title {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;

  padding-block: 12px;
  margin-bottom: 16px;

  border-top: 1px solid #e6e9f0;
  border-bottom: 1px solid #e6e9f0;
}

.step__block-row {
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 10px;
}
</style>
